import { tv } from 'tailwind-variants'

import { body2 } from '@nxt-insurance/ui-kit/core/typography'

export const BACKGROUND_IMAGE_WT_SMALL = 326
export const BACKGROUND_IMAGE_WT_LARGE = 586
const BLOG_ITEM_TEXT_MAX_HT = 100

export const blogItemDescription = tv({
  extend: body2,
  base: `overflow-hidden overflow-ellipsis max-h-${BLOG_ITEM_TEXT_MAX_HT}`,
})

export const navigationMenu = tv({
  slots: {
    root: 'mx-auto mb-4 mt-5 w-full lg:mx-auto lg:mb-5 lg:mt-0',
    list: 'flex w-full max-w-full flex-wrap justify-center gap-x-2.5',
    link: 'mb-2.5 inline-flex h-12 cursor-pointer select-none items-center whitespace-nowrap rounded-lg border-none px-4 py-0 no-underline transition-all duration-300 ease-linear hover:bg-ui-grey-50 data-[active]:bg-ui-grey-50 md:mb-0',
  },
})
